import { useEffect, useState } from "react";
import { Container, Row, Col, Card, Button, Spinner } from "react-bootstrap";

const Courses = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("https://skillsuprise.com/get-courses.php")
      .then(res => res.json())
      .then(data => {
        // ✅ LIMIT TO 8 COURSES
        setCourses(data.slice(0, 8));
        setLoading(false);
      })
      .catch(err => {
        console.error(err);
        setLoading(false);
      });
  }, []);

  // ✅ VIEW DETAILS (CORRECT URL)
  const handleViewDetails = (url, mode) => {
    window.open(
      `https://www.skillsuprise.com/course/${url}/${mode}`,
      "_blank"
    );
  };

  // ✅ VIEW MORE BUTTON
  const handleViewMore = () => {
    window.open("https://www.skillsuprise.com/courses", "_blank");
  };

  return (
    <div style={{ background: "#f5f7fa", minHeight: "100vh", padding: "40px 0" }}>
      <Container>
        <h2 className="text-center fw-bold mb-4">Our Courses</h2>

        {loading ? (
          <div className="text-center">
            <Spinner animation="border" />
          </div>
        ) : (
          <>
            <Row>
              {courses.map((course, index) => (
                <Col md={4} lg={3} key={index} className="mb-4">
                  <Card
                    style={{
                      borderRadius: "15px",
                      overflow: "hidden",
                      boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
                      border: "none",
                      height: "100%"
                    }}
                  >
                    {/* Image */}
                    <Card.Img
                      variant="top"
                      src={course.course_cover_url}
                      style={{ height: "180px", objectFit: "cover" }}
                    />

                    <Card.Body className="d-flex flex-column">
                      {/* Title */}
                      <Card.Title style={{ fontSize: "16px", fontWeight: "600" }}>
                        {course.course_title}
                      </Card.Title>

                      {/* Mode */}
                      <span
                        className="mb-2"
                        style={{
                          fontSize: "12px",
                          background: course.mode === "live" ? "#ffe0e0" : "#e0f7fa",
                          padding: "4px 10px",
                          borderRadius: "20px",
                          width: "fit-content"
                        }}
                      >
                        {course.mode.toUpperCase()}
                      </span>

                      {/* Rating */}
                      <div className="mb-2 text-muted" style={{ fontSize: "14px" }}>
                        ⭐ {course.rating} ({course.ratings})
                      </div>

                      {/* Students */}
                      <div className="mb-2 text-muted" style={{ fontSize: "13px" }}>
                        👨‍🎓 {course.course_students} students
                      </div>

                      {/* Price */}
                      <div className="mb-3">
                        <span className="fw-bold text-primary fs-5">
                          ₹{course.course_price}
                        </span>{" "}
                        <span
                          style={{
                            textDecoration: "line-through",
                            color: "#999",
                            fontSize: "14px"
                          }}
                        >
                          ₹{course.course_cutoff_price}
                        </span>
                      </div>

                      {/* Seats */}
                      <div className="mb-3 text-danger" style={{ fontSize: "13px" }}>
                        {course.seats_left} seats left
                      </div>

                      {/* Button */}
                      <Button
                        variant="primary"
                        style={{ borderRadius: "10px", marginTop: "auto" }}
                        onClick={() =>
                          handleViewDetails(course.course_url, course.mode)
                        }
                      >
                        View Details
                      </Button>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>

            {/* ✅ VIEW MORE BUTTON */}
            <div className="text-center mt-4">
              <Button
                variant="outline-primary"
                style={{ borderRadius: "25px", padding: "10px 30px" }}
                onClick={handleViewMore}
              >
                View More Courses
              </Button>
            </div>
          </>
        )}
      </Container>
    </div>
  );
};

export default Courses;